import React, { useState, useEffect } from "react";
import "./App.css";
import Airtable from "airtable";
import { Base64 as crypto } from "js-base64";
import { v4 as uuidv4 } from "uuid";
import "antd/dist/antd.css";
import { Typography, Button, Form, Input, Spin, Result } from "antd";
import { CirclePicker } from "react-color";

const AIR_TABLE_API = "a2V5eWZURWhuV3lndEtrTVEK";

const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);

const SUBMISSION_STATES = {
  SUBMITTING: "submitting",
  SENDING_TO_SERVER: "sending_to_server",
  SUBMITTED: "submitted",
};
const base = new Airtable({ apiKey: crypto.decode(AIR_TABLE_API) }).base(
  "appyGZDRxNZNUvKMi"
);

function App() {
  useEffect(() => {
    const getDataFromServer = () => {
      base("sighting_main")
        .select({
          // Selecting the first 3 records in Grid view:
          maxRecords: 100,
        })
        .eachPage(
          function page(records, fetchNextPage) {
            // This function (`page`) will get called for each page of records.
            let dataToAppend = [];
            records.forEach(function (record) {
              const numberOfCops = record.get("numberOfCops");
              const createdAt = record.get("createdAt");
              const zip = record.get("zip");
              const color = record.get("color");
              dataToAppend.push({
                numberOfCops,
                createdAt,
                zip,
                color,
              });
            });

            setData([...data, ...dataToAppend]);

            // To fetch the next page of records, call `fetchNextPage`.
            // If there are more records, `page` will get called again.
            // If there are no more records, `done` will get called.
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    };

    const script = document.createElement("script");

    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;

    document.body.appendChild(script);

    getDataFromServer();

    return () => {
      document.body.removeChild(script);
    };
  // eslint-disable-next-line
  }, []);

  const [data, setData] = useState([]);

  const [color, setColor] = useState();
  const [zip, setZip] = useState("");
  const [num, setNum] = useState("1");
  const [resultZip, setResultZip] = useState("");
  const [submissionState, setSubmissionState] = useState(
    SUBMISSION_STATES.SUBMITTING
  );

  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onColorChange = (color, event) => {
    setColor(color.hex);
  };

  const ColorBlock = ({ color }) => (
    <div
      style={{
        width: 16,
        height: 16,
        borderRadius: 6,
        backgroundColor: color,
        border: "1px solid black",
      }}
    />
  );

  const getDataToDisplay = (data, zipCode) => {
    if (!zipCode) {
      return [];
    }
    const dataForZip = data
      .filter((d) => d.zip.toString() === zipCode.toString())
      .filter((d) => new Date(d.createdAt) >= yesterday);
    const colorToNumberOfCops = dataForZip.reduce((acc, val) => {
      if (!acc[val.color]) {
        acc[val.color] = parseInt(val.numberOfCops,10);
      } else {
        acc[val.color] = acc[val.color] + parseInt(val.numberOfCops,10);
      }
      return acc;
    }, {});
    const dataToDisplay = Object.keys(colorToNumberOfCops)
      .map((color) => {
        return {
          color,
          numberOfCops: colorToNumberOfCops[color],
        };
      })
      .sort((a, b) => b.numberOfCops - a.numberOfCops);
    return dataToDisplay;
  };

  const displayData = getDataToDisplay(data, resultZip);

  const submitForm = (e) => {
    e.preventDefault();
    if (!color || !num || zip.length < 5) {
      return window.alert("Please complete all fields");
    }
    setSubmissionState(SUBMISSION_STATES.SENDING_TO_SERVER);
    const formData = {
      color: color,
      zip: zip,
      numberOfCops: num.toString(),
    };
    base("sighting_main").create(
      [
        {
          fields: {
            id: uuidv4(),
            createdAt: new Date().toISOString(),
            color: formData.color,
            zip: formData.zip,
            numberOfCops: formData.numberOfCops,
          },
        },
      ],
      function (err, records) {
        if (err) {
          return window.alert("Oops, something went wrong try again!");
        }
      }
    );
    setSubmissionState(SUBMISSION_STATES.SUBMITTED);
  };

  return (
    <div className="App">
      <header className="App-header">
        <Typography.Title style={{ color: "white" }}>
          Color Of The Day
        </Typography.Title>
        <Typography.Text style={{ color: "white" }}>
          Make protests safer, help identify undercover cops by reporting the
          color of the marker they're wearing.
        </Typography.Text>
      </header>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 2, padding: "24px" }}>
          {submissionState === SUBMISSION_STATES.SENDING_TO_SERVER && <Spin />}
          {submissionState === SUBMISSION_STATES.SUBMITTED && (
            <div>
              <Result
                status="success"
                title="Submission Success"
                subTitle="Thank you for submitting, check out results using the input field below, or refresh the page to submit another report"
              />
            </div>
          )}
          {submissionState === SUBMISSION_STATES.SUBMITTING && (
            <Form {...layout} name="basic" initialValues={{ remember: true }}>
              <Form.Item label="Enter a zipcode">
                <Input
                  placeholder="11222"
                  maxLength={5}
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="Enter a color" backgroundColor="red">
                <CirclePicker
                  color={color}
                  onChange={onColorChange}
                  colors={[
                    "#4D4D4D",
                    "#999999",
                    "#FFFFFF",
                    "#F44E3B",
                    "#FE9200",
                    "#FCDC00",
                    "#DBDF00",
                    "#A4DD00",
                    "#68CCCA",
                    "#73D8FF",
                    "#AEA1FF",
                    "#FDA1FF",
                    "#333333",
                    "#808080",
                    "#cccccc",
                    "#D33115",
                    "#E27300",
                    "#FCC400",
                    "#B0BC00",
                    "#68BC00",
                    "#16A5A5",
                    "#009CE0",
                    "#7B64FF",
                    "#FA28FF",
                    "#000000",
                    "#666666",
                    "#B3B3B3",
                    "#9F0500",
                    "#C45100",
                    "#FB9E00",
                    "#808900",
                    "#194D33",
                    "#0C797D",
                    "#0062B1",
                    "#653294",
                    "#AB149E",
                  ]}
                />
              </Form.Item>
              <Form.Item label="Enter number of cops">
                <Input
                  value={num}
                  onChange={(e) => setNum(e.target.value)}
                  type={"number"}
                />
              </Form.Item>
              <Form.Item>
                <Button onClick={submitForm} type="primary">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
          <hr />
          <div style={{ padding: "24px" }}>
            <Typography.Text>
              Lookup possible sightings by color for the past day
            </Typography.Text>
            <Form.Item label="Enter a zip code">
              <Input
                value={resultZip}
                maxLength={5}
                onChange={(e) => {
                  setResultZip(e.target.value);
                }}
              />
            </Form.Item>
            {resultZip.length < 5 && (
              <Typography.Paragraph>
                Enter a zip code in the field above to lookup
              </Typography.Paragraph>
            )}
            {resultZip.length === 5 && (
              <div>
                <Typography.Paragraph>
                  Results for Zip Code <strong>{resultZip}</strong> after{" "}
                  {yesterday.toISOString()}:
                </Typography.Paragraph>
                {!displayData.length && <Typography.Paragraph>No results</Typography.Paragraph>}
                <div>
                  {displayData.map((d, idx) => (
                    <div
                      style={{ display: "flex", padding: "6px" }}
                      key={`result_${idx}`}
                    >
                      <ColorBlock color={d.color} />
                  <span>{d.numberOfCops} {d.numberOfCops == 1 ? 'cop' : 'cops'}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div style={{ flex: 1, padding: "24px" }}>
          <blockquote
            class="twitter-tweet"
            data-theme="dark"
            data-dnt="true"
            align="center"
          >
            <p lang="en" dir="ltr">
              NYC friends, I noticed all the undercover cops are wearing white
              arm bands, probably to recognize each other. Be careful.{" "}
              <a href="https://t.co/DjRYBemW3b">pic.twitter.com/DjRYBemW3b</a>
            </p>
            &mdash; Zack Bornstein (@ZackBornstein){" "}
            <a href="https://twitter.com/ZackBornstein/status/1266547600330600448?ref_src=twsrc%5Etfw">
              May 30, 2020
            </a>
          </blockquote>
        </div>
      </div>
      <div style={{margin: '0 auto', display: 'inline-flex'}}>
          <Typography.Paragraph style={{marginRight: '12px'}}>Donate:</Typography.Paragraph>
          <Typography.Paragraph><a href="https://brooklynbailfund.org/donate">Brooklyn Bail Fund</a></Typography.Paragraph>
          <Typography.Paragraph>|</Typography.Paragraph>
          <Typography.Paragraph><a href="https://minnesotafreedomfund.org/donate/">Minnesota Freedom Fund</a></Typography.Paragraph>
          <Typography.Paragraph>|</Typography.Paragraph>
          <Typography.Paragraph><a href="http://www.blackbailout.org/">Colorado Freedom Fund</a></Typography.Paragraph>
        </div>
    </div>
  );
}

export default App;
